import { z } from 'zod';

const raffleWinnerForOrganizerSchema = z.object({
  userId: z.string(),
  userSearchID: z.string(),
  fullname: z.string(),
  cohortId: z.string().nullable(),
  dispensaries: z.array(z.string()),
  prize: z.string(),
  endDate: z.coerce.date(),
  collectedAt: z.coerce.date().nullable(),
  raffleId: z.string(),
  createdAt: z.coerce.date(),
});

export const raffleWinnersOrganizerResDto = z.array(
  raffleWinnerForOrganizerSchema,
);
export type RaffleWinnersOrganizerResDto = z.infer<
  typeof raffleWinnersOrganizerResDto
>;
